export default __webpack_public_path__ + "static/media/crypto.c17bdd15.svg";